import ModalVideo from 'modal-video';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    new ModalVideo('.js-modal-video', {
        youtube: {
            color: null,
            autoplay: 1,
            rel: 0,
        },
        autoplay: 1,
        channel: 'youtube',
    });
    
    /**
     * Mobile Header Navigation Show
     */

    $(document)

      .on('load', function () {
        cardSliderInit();
      })
      .on('click', '.product-filter-hamburger', function () {
        $('#product-filters').toggleClass('d-none');
        $(this).closest('.sm-products').find('.opacity-bg-gray').toggleClass('d-none');
      })
      .on('click', '.single-filter-header-clickable', function () {
        $(this).parent().toggleClass('open');
      })
      .on('click', '.product-filter-checkbox', function () {

        var promises = $('.product-filter-checkbox:checked')
          .map(function(){
            return {
              'taxonomy'  : $(this).prop('name'),
              'val'       : $(this).val(),
            } })
          .get();

        let $product = $('.sm-products__single');
        let $product_count = $('.sm-products__product-count');

        Promise.all(promises)
          .then(function(taxes) {
            let counter = 0;
            $product_count.text(counter);
            $product.hide('slow');
            $product.removeClass('render_lug');

            if(taxes.length === 0) {
              $product.show('slow');
              $product.addClass('render_lug');
              $product_count.text($product.length);
            }

            $(taxes).each(function(index, tax) {
              $product.each( function () {
                if($(this).data('taxonomy-' + tax.taxonomy).toString().split(',').includes(tax.val)) {
                  $(this).show('slow');
                  $(this).addClass('render_lug');

                  if($(this).hasClass('render_lug') && $(this).attr('data-lagerungs')){
                    let block = $(this);
                    let old_link = $(this).find('.sm-products__single-hover a').attr('href');

                    if(typeof($(this).data( 'lagerungs' ))!=='undefined' && $(this).data( 'lagerungs' ).length>0  ){
                      let lag_arr = $(this).data( 'lagerungs' ).split(',');
                      if(taxes.length>0 ){
                        let storage = lag_arr.indexOf(taxes[0].val);

                        if(storage>=0){
                          old_link += '?storage='+storage+'&color=0';
                          block.find('.sm-products__single-hover a').attr('href',old_link);
                        }
                        block.find('.sm-products__single-hover a').attr('href',old_link);
                      }
                      else{
                        $(this).removeClass('render_lug');
                      }
                    }

                  }

                  setTimeout(function () {
                    counter = counter + 1;
                    $product_count.text(counter);
                  }, 500 * counter);
                }
              });
            });

            // $('.sm-products__single')
            //   .each( function () {
            //
            //     let that = this;
            //
            //
            //     $(taxes).each( function (index, tax) {
            //       console.log(tax);
            //       show.push(!!$(that).data('taxonomy-' + tax.taxonomy).toString().split(',').includes(tax.val));
            //     });
            //
            //     if ( show.every( function (el) { return el; })) {
            //       $(this).show('slow');
            //
            //       $(this).addClass('render_lug');
            //
            //       if($(this).hasClass('render_lug') && $(this).attr('data-lagerungs')){
            //         let block = $(this);
            //         let old_link = $(this).find('.sm-products__single-hover a').attr('href');
            //
            //         if(typeof($(this).data( 'lagerungs' ))!=='undefined' && $(this).data( 'lagerungs' ).length>0  ){
            //           let lag_arr = $(this).data( 'lagerungs' ).split(',');
            //             if(taxes.length>0 ){
            //               let storage = lag_arr.indexOf(taxes[0].val);
            //
            //               if(storage>=0){
            //                 old_link += '?storage='+storage+'&color=0';
            //                 block.find('.sm-products__single-hover a').attr('href',old_link);
            //               }
            //               block.find('.sm-products__single-hover a').attr('href',old_link);
            //             }
            //             else{
            //               $(this).removeClass('render_lug');
            //             }
            //           }
            //
            //       }
            //
            //
            //       setTimeout(function () {
            //         counter = counter + 1;
            //         $('.sm-products__product-count').text(counter);
            //       }, 500 * counter);
            //
            //     } else {
            //       $(this).hide('slow');
            //       $(this).removeClass('render_lug');
            //     }
            //
            //   });


        });
      })
      .on('click', '.product-faq-header-button', function () {
        $(this).toggleClass('active');
      })
      .on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top,
        }, 1000);
      });

    $(window)


    $('.menu-button').on('click', function () {
      $('.menu-button i').toggleClass('sm-icon-menu').toggleClass('sm-icon-close');
      $('#mobile-navigation').toggleClass('header-navigation_mobile--open');
      $('body').toggleClass('body-overflow-hidden');
    });

    $('#banner-bg-image')
      .delay(100)
      .animate({'opacity':'1'}, 500);

    /**
     * Bootstrap Tooltips
     */
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    });



    /**
     * Card list slider
     */
    function cardSliderInit() {
      $('.sm-slider-cards')
        .slick({
          dots: true,
          dotsClass: 'slick-dots is-customized is-blue',
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          centerMode: false,
          variableWidth: true,
          arrows: true,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                centerMode: true,
              },
            },
          ],
        });
    }

    /**
     * Masonry list slider
     */
    function masonrySliderInit() {
      $('.sm-slider-images')
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.sm-slider-nav-images',
        });

        $('.sm-slider-nav-images').slick({
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true,
          centerMode: false,
          variableWidth: true,
          arrows: false,
          slidesToScroll: 1,
          asNavFor: '.sm-slider-images',
          dots: true,
          focusOnSelect: true,
          dotsClass: 'slick-dots is-customized is-blue',
        });
    }
    function GetYoutubeVideoId(url){
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }

    function productSliderInit() {
      let $product_slider = $('#sm-product-slider');
      if($product_slider.length ) {
          const images          = $product_slider.data('images-src');
          const slideControls   = $('#sm-product-slider-dot');

          $product_slider
              .slick({
                  mobileFirst: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  adaptiveHeight: false,
                  centerMode: true,
                  arrows: true,
                  fade: true,
                  infinite: true,
                  dots: true,
                  rows: 0,
                  asNavFor: $('#slider-in-popup'),
                  responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                        appendDots: slideControls,
                        customPaging: function (slider, i) {
                          switch (images[i].type) {
                            case 'image':{
                              return '<a class="dot" role="button" style="background-image: url('+images[i].link+')"></a>';
                            }
                            case 'video':{
                              return '<a class="dot video" role="button" style="background-color: #fff"></a>';
                            }
                            case 'youtube':{
                              const preview = `https://img.youtube.com/vi/${GetYoutubeVideoId(images[i].link)}/1.jpg`;
                              return '<a class="dot video" role="button" style="background-image: url('+preview+')"></a>';
                            }
                          }
                        },
                      },
                    },
                  ],
              });
      }

    }

    function sliderInPopupInit() {
      let $slider = $('#slider-in-popup');
      if($slider.length ) {
        const images          = $slider.data('images-src');
        const slideControls   = $('#slider-in-popup-dot');

        $slider
          .slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            centerMode: true,
            arrows: true,
            fade: true,
            infinite: true,
            dots: true,
            initialSlide: $('#sm-product-slider').slick('slickCurrentSlide'),
            rows: 0,
            asNavFor: $('#sm-product-slider'),
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  appendDots: slideControls,
                  customPaging: function (slider, i) {
                    switch (images[i].type) {
                      case 'image':{
                        return '<a class="dot" role="button" style="background-image: url('+images[i].link+')"></a>';
                      }
                      case 'video':{
                        return '<a class="dot video" role="button" style="background-color: #fff"></a>';
                      }
                      case 'youtube':{
                        const preview = `https://img.youtube.com/vi/${GetYoutubeVideoId(images[i].link)}/1.jpg`;
                        return '<a class="dot video" role="button" style="background-image: url('+preview+')"></a>';
                      }
                    }
                  },
                },
              },
            ],
          });
      }

    }
    function sliderInPopupConf(){
      const scalableImages = document.querySelectorAll('.sm-product-slider__slider-single img');

      Array.prototype.forEach.call(scalableImages, function(b) {
        b.addEventListener('click', function(event) {
          event.preventDefault();
          $('body').addClass('body-overflow-hidden');
          $('.scalable-img-lightbox.slider').addClass('show');

          $('#slider-in-popup').slick('setPosition').slick('slickGoTo', $('#sm-product-slider').slick('slickCurrentSlide'), false);

        });
      });
    }
    // TODO: stop video in slide when swiping

    $('#sm-product-slider').on('beforeChange', function(){
      if($('#sm-product-slider .slick-current').find('iframe.sm-product-slider__yt-video').length > 0) {
        // const video = $('#sm-product-slider .slick-current').find('iframe.sm-product-slider__yt-video');
        // video.get(0).stopVideo();
      } else if ($('#sm-product-slider .slick-current').find('video.sm-product-slider__video-big').length > 0) {
        $('#sm-product-slider .slick-current').find('video.sm-product-slider__video-big').trigger('pause');
      }
    });

    $('#slider-in-popup').on('beforeChange', function(){
      if($('#slider-in-popup .slick-current').find('iframe.sm-product-slider__yt-video').length > 0) {
        // const video = $('#sm-product-slider .slick-current').find('iframe.sm-product-slider__yt-video');
        // video.get(0).stopVideo();
        // video.trigger('pause');
      } else if ($('#slider-in-popup .slick-current').find('video.sm-product-slider__video-big').length > 0) {
        $('#slider-in-popup .slick-current').find('video.sm-product-slider__video-big').trigger('pause');
      }
    });

    function referenceSliderInit() {
        let $reference_slider = $('.single-reference-slider');

        $reference_slider.each(function (idx) {
            let slideId = '#reference_slider_' + idx;
            let mobileSlideId = '#sub_reference_slider_' + idx;
            let dotId = '#reference_dot_' + idx;
            $(slideId).slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                centerMode: true,
                centerPadding: '0',
                appendDots: dotId,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            variableWidth: true,
                            centerMode: false,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: false,
                            centerMode: true,
                            centerPadding: '15px',
                            asNavFor: mobileSlideId,
                        },
                    },
                ],
            });

            $(mobileSlideId).slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                variableWidth: false,
                adaptiveHeight: true,
                dots: false,
                arrows: false,
                centerMode: false,
                centerPadding: '15px',
                asNavFor: slideId,
            });
        });
    }

    /**
     * Product XY page - models & types slider
     */

    function productModelsSliderInit() {
      const initSlider = (selector) => {
        const items = document.querySelectorAll(`${selector} a`);

        const sliderProps = {
          slidesToScroll: 1,
          slidesToShow: 1,
          centerMode: false,
          infinite: items.length > 4,
          speed: 300,
          arrows: true,
          rows: 0,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
              },
            },
          ],
        };
        $(selector).slick(sliderProps);
      }

      initSlider('.sm-product-type__model-slider');
      initSlider('.sm-product-type__type-slider');

      const curModelSlide = $('.sm-product-type__model-option.active').closest('.slick-slide');
      $('.sm-product-type__model-slider').slick('slickGoTo', curModelSlide.attr('data-slick-index'), true);

      const curTypeSlide = $('.sm-product-type__type-option.active').closest('.slick-slide');
      $('.sm-product-type__type-slider').slick('slickGoTo', curTypeSlide.attr('data-slick-index'), true);

    }

    /**
     * Product XY page - slider in tabs (Oberflächen & Lagerung)
     */

    function productParametersSlidersInit() {
      const sliderProps = {
        slidesToScroll: 1,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        centerMode: false,
        arrows: true,
        variableWidth: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              arrows: true,
            },
          },
        ],
      };

      $('.sm-product-about__slider-surface').slick(sliderProps);
      $('.sm-product-about__slider-storage').slick(sliderProps);

      $('a[data-toggle="tab"]').on('shown.bs.tab', function () {
        $('.sm-product-about__slider-surface').slick('setPosition');
        $('.sm-product-about__slider-storage').slick('setPosition');
      });
    }

    /**
     * Product XY page - credentials sliders (Referenzen)
     */

    function productCredentialsSlidersInit() {
      $('.sm-product-credentials__slider').slick({
        infinite: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 300,
        centerMode: false,
        arrows: false,
        variableWidth: true,
      });
    }

    $(document).ready(function(){


        cardSliderInit();
        masonrySliderInit();
        productSliderInit();
        referenceSliderInit();
        productModelsSliderInit();
        productParametersSlidersInit();
        productCredentialsSlidersInit();
        sliderInPopupInit();
        sliderInPopupConf();



      $('[class*=sm-product-type__model-option]').click(function ()  {
        $('.sm-product-type__model-option.active').removeClass('active');
        $(this).addClass('active')
      });
      $('[class*=sm-product-type__type-option]').click(function ()  {
        $('.sm-product-type__type-option.active').removeClass('active');
        $(this).addClass('active')
      });

      $('[class*=slider-surface] .sm-product-about__slider-option').click(function ()  {
        $('[class*=slider-surface] .sm-product-about__slider-option.active').removeClass('active');
        $(this).addClass('active')
      });
      $('[class*=slider-storage] .sm-product-about__slider-option').click(function ()  {
        $('[class*=slider-storage] .sm-product-about__slider-option.active').removeClass('active');
        $(this).addClass('active')
      });

    });

    /*
      Product collapse block
    */

    $('.product-collapse-block__button').on('click', function () {
      $(this).closest('.product-collapse-block').toggleClass('active');
    });

    /*
      End
    * */

    $('#form-submit').on('click', function(e){
        e.preventDefault();

        let userName = $('#newsletter-form-name').val();
        let userMail = $('#newsletter-form-email').val();
        let alert = $('.alert');

        $.ajax({
            url: './wp-admin/admin-ajax.php?action=new_user',
            type: 'POST',
            data: {
                name: userName,
                mail: userMail,
            },
            beforeSend: function() {
                $('#form-submit').addClass('disable');
            },
            success: function( data ) {
                $('#form-submit').removeClass('disable');
                alert.text(data);
                alert.slideDown();
                setTimeout(function(){
                    alert.slideUp();
                },5000);
            },
        });
    });

    $('.header-search-input').on('click', function() {
      if (matchMedia('all and (min-width: 1024px)').matches) {
        $(this).addClass('header-search-input--active');
        $(this).children('input').focus();

        $(document).mouseup(function (e){
          var div = $('.header-search-input');
          if (!div.is(e.target) && div.has(e.target).length === 0) {
            div.removeClass('header-search-input--active');
          }
        });
      } else {
        $('.header-search-popup').addClass('header-search-popup--show');
      }

      $('.header-search-popup button').on('click', function() {
        $('.header-search-popup').removeClass('header-search-popup--show');
      });
    });


    var subMenuBtn = document.querySelectorAll('.nav-primary > .menu-item-has-children');
    Array.prototype.forEach.call(subMenuBtn, function(b) {
      b.onclick = function(event) {
        if(matchMedia('all and (max-width: 1399px)').matches) {
          event.stopPropagation();
          event.target.classList.toggle('menu-item-has-children--open');
          event.target.classList.add('menu-item-has-children--click');
          $('.menu-item-has-children--click .menu-item-has-children').toggleClass('menu-item-has-children--open');
          $('.menu-item-has-children--click').removeClass('menu-item-has-children--click');

        }
      };
    });

    var mainHeader = $('.header-navigation_desktop');
    $(window).scroll(function(){
      if(matchMedia('all and (min-width: 1400px)').matches) {
        var st = $(this).scrollTop();
        if (st > 10) {
          mainHeader.addClass('header-navigation__scroll-down');
        } else {
          mainHeader.removeClass('header-navigation__scroll-down');
        }
      }
    });

    $(document).ready(function(){
      $('a[href^="#cat"]').click(function (event)  {
        event.preventDefault();
        var id = $(this).attr('href'),
          top = $(id).offset().top;
        $('body,html').animate({scrollTop: top-110}, 1800);
      });
    });

    $(document).ready(function(){
      $(window).scroll(function(){
        if ($(this).scrollTop() > 100) {
          $('.scrollTop-btn').fadeIn();
        } else {
          $('.scrollTop-btn').fadeOut();
        }
      });
      $('.scrollTop-btn').click(function(){
        $('html, body').animate({
          scrollTop: 0,
        }, 600);
        return false;
      });
    });

    $(document).ready(function(){
      let pdfLinks = document.querySelectorAll('a[href$=".pdf"]');

      if($('body').hasClass('single-sm_product')) {
        $('#pdfModalLabel').hide();
      }

      Array.prototype.forEach.call(pdfLinks, function(b) {
        b.addEventListener('click', function(event) {
          if (matchMedia('(min-width: 768px)').matches) {
            event.preventDefault();
            b.setAttribute('data-toggle', 'modal');
            b.setAttribute('data-target', '#pdfModal');
            $('body').addClass('body-overflow-hidden');

            let currentPdfLink = b.href;
            let currentPdfName;

            if ($(this).find('.sm-card__title').length) {
              currentPdfName = $(this).find('.sm-card__title').text();
            } else {
              currentPdfName = b.textContent;
            }

            $('#pdfModal .modal-title').text(currentPdfName);
            $('#pdfFrame').attr('src', currentPdfLink);
          } else {
            event.preventDefault();
            let currentPdfLink = b.href;
            window.open(currentPdfLink, '_blank');
          }
        });
      });

      $('#pdfModal').on('hide.bs.modal', function () {
        $('#pdfModal .modal-title').text('File name');
        $('#pdfFrame').removeAttr('src');
        $('body').removeClass('body-overflow-hidden');
      })

    });

    const imagesNeedLightbox = document.querySelectorAll('.sm-product-details img');
    for (let i = 0; i < imagesNeedLightbox.length; i++) {
      const wrapper = document.createElement('div');
      wrapper.setAttribute('class', 'scalable-img');
      wrapper.style.display = 'inline-block';
      imagesNeedLightbox[i].parentNode.insertBefore(wrapper, imagesNeedLightbox[i]);
      wrapper.appendChild(imagesNeedLightbox[i]);
    }

    // Images with lightbox

    $(document).ready(function(){
      const scalableImages = document.querySelectorAll('.scalable-img img');

      Array.prototype.forEach.call(scalableImages, function(b) {
        b.addEventListener('click', function(event) {
          event.preventDefault();
          const imgLink = b.src;
          $('body').addClass('body-overflow-hidden');
          $('.scalable-img-lightbox:not(.slider)').addClass('show');
          $('.scalable-img-lightbox__image').attr('src', imgLink);
        });
      });

      function hideLightbox() {
        $('body').removeClass('body-overflow-hidden');
        $('.scalable-img-lightbox:not(.slider)').removeClass('show');
      }

      $('.scalable-img-lightbox:not(.slider) .scalable-img-lightbox__overlay').on('click', function(e){
        e.preventDefault();
        hideLightbox()
      });

      $('.scalable-img-lightbox:not(.slider) .scalable-img-lightbox__btn').on('click', function(e){
        e.preventDefault();
        hideLightbox()
      });

      $(document).on('keydown',function(event) {
        if (event.keyCode == 27 && $('.scalable-img-lightbox:not(.slider)').hasClass('show')) {
          hideLightbox()
        }
      });

    });


    // Popup for slider

    $(document).ready(function(){


      function hideLightbox() {
        $('body').removeClass('body-overflow-hidden');
        $('.scalable-img-lightbox.slider').removeClass('show');
      }

      $('.scalable-img-lightbox.slider .scalable-img-lightbox__overlay').on('click', function(e){
        e.preventDefault();
        hideLightbox()
      });

      $('.scalable-img-lightbox.slider .scalable-img-lightbox__btn').on('click', function(e){
        e.preventDefault();
        hideLightbox()
      });

      $(document).on('keydown',function(event) {
        if (event.keyCode == 27 && $('.scalable-img-lightbox.slider').hasClass('show')) {
          hideLightbox()
        }
      });

    });

    if ( document.querySelector('.model-desc-icon')) {
      $('.model-desc-icon').hover(function() {
        const text = this.dataset.infotext;
        const img = this.dataset.infoimage;

        // if (!isNaN(img) && img !== '' && img) {
        //   $('product-model-desc__images-wrapper').addClass('show');
        // }

        $('.product-model-desc').css('display','inline-block').addClass('active');
        $('.product-model-desc__text').html(text);
        $('.product-model-desc__image').attr('src', img);
      }, function() {
        $('.product-model-desc').removeClass('active').hide();
        // $('product-model-desc__images-wrapper').removeClass('show');
      })
    }

    /*
      ÜManagement DOWNLOAD
    */

    if ( document.querySelector('.download-software__form')) {
      $('.download-software__input-wrapper').popover({
        placement: 'bottom',
        trigger: 'manual',
        offset: 'left',
      }).popover('disable');

      $('.download-software__form input').change(function() {
        $(this).removeClass('error');
        $(this).parent('.download-software__input-wrapper').popover('hide').popover('disable');
      });

      $('.download-software__form').submit(function( event ) {
        event.preventDefault();
        const button = $(this).find('button');
        const input = $(this).find('input');
        const code = $(this).find('input').val();
        const popover = $(this).find('.download-software__input-wrapper');
        const spinner = $(this).find('svg');


        if (code !== '') {
          button.attr('disabled', true);
          spinner.addClass('show');

          fetch(`/wp-json/downloads/check/${code}/`)
          .then(response => response.json())
          .then(result => {
            button.removeAttr('disabled')
            spinner.removeClass('show');

            if (result.code === 'code_is_valid') {
              window.open(`${window.location.origin}/wp-json/downloads/download/${code}`,'_blank');
              input.val('');

            } else {
              if ( result.code === 'rest_invalid_param') {
                popover.attr('data-content', 'Code ungültig');

              } else if ( result.code === 'code_expired') {
                popover.attr('data-content', 'Code is expired');

              } else if ( result.code === 'no_file_assigned') {
                popover.attr('data-content', 'No file assigned');

              } else {
                popover.attr('data-content', result.message).popover('enable');
              }

              input.addClass('error');
              popover.popover('enable').popover('show');
            }
          })
        } else if (code === '') {
          popover.attr('data-content', 'Dieses Feld darf nicht leer sein');
          popover.popover('enable').popover('show');
        }
      });
    }
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js